var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-wrapper"},[_c('b-container',{staticClass:"settings-cont",attrs:{"tag":"section"}},[_c('b-row',[_c('b-col',{staticClass:"mb-5",attrs:{"sm":"12","md":"10","offset-md":"1"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }